/**
 * External dependencies
 */
import { combineReducers } from 'redux';
/**
 * Internal dependencies
 */

import { createReducer } from 'state/utils';
import {
    CURRENT_KIOSK_RECEIVE,
    CURRENT_KIOSK_REQUEST,
    CURRENT_KIOSK_REQUEST_SUCCESS,
    CURRENT_KIOSK_REQUEST_FAILURE,
} from 'state/action-types';

export const requesting = createReducer(false, {
    [CURRENT_KIOSK_REQUEST]: () => true,
    [CURRENT_KIOSK_REQUEST_SUCCESS]: () => false,
    [CURRENT_KIOSK_REQUEST_FAILURE]: () => false,
});

const items = createReducer(null, {
    [CURRENT_KIOSK_RECEIVE]: (state, action) => action.payload.kioskplan,
});

export const error = createReducer(false, {
    [CURRENT_KIOSK_REQUEST]: () => false,
    [CURRENT_KIOSK_REQUEST_SUCCESS]: () => false,
    [CURRENT_KIOSK_REQUEST_FAILURE]: () => true,
});

export default combineReducers({
    items,
    requesting,
    error
});
